import { useEffect } from "react";

export default function DriverUploadPage() {
	useEffect(() => {
		window.location.href = "/driver/bulk/create/";
	}, []);

	return null;
}
